





import {Vue, Component} from 'vue-property-decorator';

import {enableLanguages} from '@/plugins/i18n/i18n';
import {AppModule} from '@/store/modules/app';

@Component
export default class App extends Vue {
  public created() {
    this.setErrorCode()
  }

  public mounted() {
    this.setWindowVH()
    this.setLocale()
    window.addEventListener('resize', () => {
      this.setWindowVH()
    });
  }

  public setWindowVH() {
    // --vhというカスタムプロパティを作成
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  public setLocale() {
    const locale = this.$route.query ? this.$route.query.lang : ''
    if (typeof locale === 'string' && enableLanguages.includes(locale)) {
      this.$i18n.locale = locale;
      document.documentElement.lang = locale;
    }
  }

  public setErrorCode() {
    if (this.$route.query && typeof this.$route.query.err_code === 'string') {
      AppModule.setErrCode(this.$route.query.err_code)
    }
  }
}
